module.exports = __webpack_public_path__ + "img/payment-icon1.4d41a1c6.png";